"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Dimensions {
    constructor(width, height) {
        this._width = 0;
        this._height = 0;
        this._width = width;
        this._height = height;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    scaleToFit(maxDimensions) {
        const aspectRatio = this.width / this.height;
        const maxAspectRatio = maxDimensions.width / maxDimensions.height;
        if (this.width <= maxDimensions.width && this.height <= maxDimensions.height) {
            return new Dimensions(this.width, this.height);
        }
        if (aspectRatio > maxAspectRatio) {
            return new Dimensions(maxDimensions.width, Math.floor(maxDimensions.width / aspectRatio));
        }
        else {
            return new Dimensions(Math.floor(maxDimensions.height * aspectRatio), maxDimensions.height);
        }
    }
}
exports.default = Dimensions;
